var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.77 1.75)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.398 0C3.761 0 .014 3.754.014 8.4l.003.212a8.589 8.589 0 001.511 4.61l.01.012.003.026L0 16.9l3.67-1.56-.085-.057C5.039 16.284 6.65 16.8 8.398 16.8c4.638 0 8.384-3.754 8.384-8.4 0-4.646-3.746-8.4-8.384-8.4zm0 .8c4.196 0 7.584 3.395 7.584 7.6S12.594 16 8.398 16l-.215-.003a7.504 7.504 0 01-3.963-1.252l-.088-.059-.011-.017a.478.478 0 00-.236-.17.643.643 0 00-.243-.03l-.055.005a.517.517 0 00-.321.16l-.011.013-1.747.743.835-1.973v-.08a1.3 1.3 0 00-.016-.237l-.015-.072a.67.67 0 00-.121-.259l-.01-.011.007.011A7.773 7.773 0 01.814 8.4C.814 4.195 4.203.8 8.398.8z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.412 11.048c-.17 0-.34-.17-.34-.34V8.754c0-.17.17-.34.34-.34a1.883 1.883 0 001.865-1.868c0-1.02-.848-1.87-1.865-1.87-1.018 0-1.865.85-1.865 1.87 0 .17-.17.34-.34.34-.169 0-.339-.17-.339-.34a2.644 2.644 0 012.629-2.634 2.644 2.644 0 012.628 2.634c0 1.274-.933 2.378-2.204 2.548v1.614c-.17.17-.34.34-.51.34z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.479,
    cy: 12.5,
    r: 1
  }))));
}
export default SvgQuestionDisabled;